import { Component, OnInit, Input } from '@angular/core';
import { StaffService } from 'src/app/model/staff.service';
import { UserDataService } from 'src/app/model/user-data.service';

@Component({
  selector: 'app-text-chart',
  templateUrl: './text-chart.component.html',
  styleUrls: ['./text-chart.component.scss']
})
export class TextChartComponent implements OnInit {
  @Input() userListModel: any;
  router: any;
  searchParams: any;
  totalCount: any;
  errorMessage: any;
  currentPage: number;
  pageSize: number;
 
  constructor(private staffService: StaffService, private users: UserDataService) { }

  ngOnInit() {
  
  }




}
